import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const TermsOfService = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container mx-auto px-4 max-w-4xl">
        <button
          onClick={() => navigate(-1)}
          className="mb-6 flex items-center text-purple-600 hover:text-purple-800 transition-colors"
        >
          <ArrowLeft className="w-5 h-5 mr-2" />
          Back
        </button>

        <div className="bg-white rounded-lg shadow-md p-8">
          <h1 className="text-3xl font-bold text-center mb-8">Terms of Service</h1>
          <p className="text-gray-500 text-center mb-8">Last Updated: April 30, 2025</p>

          <div className="prose max-w-none">
            <p className="font-bold text-red-600 mb-4 text-center">
              FOR ENTERTAINMENT PURPOSES ONLY
            </p>
            
            <p>
              Welcome to PsychicsInsights.com ("Site", "Platform", "we", "us", or "our"). By accessing or using our services, you agree to be bound by these Terms of Service ("Terms").
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">1. Eligibility</h2>
            <p>
              You must be at least 18 years old to use this platform. By using this site, you confirm that you meet this requirement.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">2. Services Provided</h2>
            <p>
              PsychicsInsights.com connects users with psychic advisors who offer insights through live chat or messaging. These services are intended for entertainment purposes only and are not a substitute for professional medical, legal, or financial advice.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">3. Account Registration</h2>
            <p>
              To access services, you may be required to create an account and provide personal information including your name, email address, and payment details. You agree to provide accurate and current information.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">4. Payments</h2>
            <p>
              Payments are securely processed via Stripe. By using our services, you agree to pay the stated fees for readings or sessions. We reserve the right to change pricing at any time.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">5. Refunds</h2>
            <p>
              All purchases are non-refundable unless otherwise specified. If you believe you were charged in error, contact us at psychicsinsights@gmail.com within 7 days of the transaction.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">6. User Conduct</h2>
            <p>
              You agree not to:
            </p>
            <ul>
              <li>Harass or abuse advisors or other users</li>
              <li>Post or share offensive, illegal, or inappropriate content</li>
              <li>Attempt to defraud or manipulate the platform</li>
              <li>Violate any applicable laws or regulations</li>
            </ul>
            <p>
              Violations may result in account suspension or permanent removal.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">7. Advisor Conduct</h2>
            <p>
              Advisors are independent contractors who provide services based on their own spiritual or intuitive practices. While we expect all advisors to behave professionally and ethically, we are not liable for any advice, guidance, or outcomes provided.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">8. Off-Platform Interactions</h2>
            <p>
              If you choose to engage with an advisor outside of PsychicsInsights.com, including for healing services, consultations, or any personal or business arrangements, you do so at your own risk. PsychicsInsights.com is not responsible or liable for any outcomes, harm, disputes, or financial loss resulting from such interactions. We strongly advise users to keep all communication and transactions within the platform for their safety and protection.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">9. Disclaimer of Warranties</h2>
            <p>
              Services are provided "as is" without warranties of any kind. We do not guarantee the accuracy, effectiveness, or truth of any reading or information received from advisors.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">10. Limitation of Liability</h2>
            <p>
              To the fullest extent allowed by law, PsychicsInsights.com shall not be liable for any indirect, incidental, or consequential damages arising from your use of our services or content.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">11. Modifications</h2>
            <p>
              We may update these Terms at any time. Continued use of the site means you agree to the latest version.
            </p>

            <h2 className="text-xl font-semibold mt-8 mb-4">12. Contact</h2>
            <p>
              Questions or concerns?<br />
              Email: psychicsinsights@gmail.com<br />
              Website: www.psychicsinsights.com
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;